module.exports = __webpack_public_path__ + "static/img/tv.94a912bd.svg";